import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {
	init() {

		function MobileMenu () {

			var hamburger = document.querySelector('.header__hamburger');	
			var menu = document.querySelector('.mobileMenu');
			

			var menuContent = menu.querySelector('.mobileMenu--size');
			var items = menuContent.querySelectorAll('.menuItem');


			hamburger.addEventListener('click', function() {

				if( menu.classList.contains('active') ) {

					menu.classList.remove('active');

				} else {

					menu.classList.add('active');
					
				}

			});

			menu.addEventListener('click',function() {

				menu.classList.remove('active');

			});

			menuContent.addEventListener('click',function(e){

				e.stopPropagation();

			});

			items.forEach( function( item,index ) {

				item.addEventListener('click',function() {

					menu.classList.remove('active');
					
				});

			});

		}

		function MainMenu() {
			
			var header = document.querySelector('header');

			var main = document.querySelectorAll('main');

			var controller = new ScrollMagic.Controller();

			new ScrollMagic.Scene({triggerElement: main, triggerHook: 0 })
				// trigger animation by adding a css class
				.setClassToggle(header, "backgroundWhite")
				// .addIndicators({name: "- Subpage "}) // add indicators (requires plugin)
				.addTo(controller)
				.offset(1);

		}

		var container = document.querySelector('.header');

		if( container ) {

			MainMenu();

			MobileMenu();

		}
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
